export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6356.ed4d0547.jpg";